import { memo, forwardRef } from "react";
import { CustomContentProps, SnackbarContent } from "notistack";
import styles from "./PatientThemeResponsiveSnackbar.module.scss";
import CheckIcon from "../../icon-components/CheckIcon";
import InfoIcon from "../../icon-components/InfoIcon";
import { Typography } from "@mui/material";

const PatientThemeResponsiveSnackbar = forwardRef<
  HTMLDivElement,
  CustomContentProps
>((props, forwardedRef) => {
  const { message, variant } = props;
  const rootClass = `${styles.root} ${styles[variant]}`;

  const iconMap: Record<string, JSX.Element> = {
    success: <CheckIcon />,
    error: <InfoIcon />,
  };

  return (
    <SnackbarContent
      ref={forwardedRef}
      className={rootClass}
    >
      <Typography variant="subtitle2" className={styles.message}>
        {iconMap[variant]}
        {message}
      </Typography>
    </SnackbarContent>
  );
});

export default memo(PatientThemeResponsiveSnackbar);
